import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = ["data-testid", "data-sla-state", "data-sla-outcome", "title"]
const _hoisted_2 = {
  viewBox: "0 0 24 24",
  class: "h-3.5 w-3.5 shrink-0",
  fill: "currentColor",
  "aria-hidden": "true"
}
const _hoisted_3 = ["d"]

import { computed } from 'vue'
import {
  mdiAlertCircleOutline,
  mdiAlertOutline,
  mdiCheck,
  mdiClockOutline,
  mdiProgressClock
} from '@mdi/js'

import { describeModuleViewSla } from './moduleViewSlaFormat'
import type { ModuleViewSlaTone } from './moduleViewSlaFormat'
import type { ModuleViewSla } from './types'

/**
 * Chip de SLA do contrato ModuleView (spec 2026-10-01 §7.3, G2-D12). Genérico: Registro de
 * plantão hoje, Solicitações e a visão agregada depois. O estado anda no tique (`nowMs`, um
 * relógio por tela via `useServerNowTick`); ícone + cor, o estado não depende só da cor.
 */

export default /*#__PURE__*/_defineComponent({
  __name: 'ModuleViewSlaChip',
  props: {
    sla: {},
    nowMs: { default: null },
    testId: { default: 'module-view-sla-chip' }
  },
  setup(__props: any) {

const props = __props;



const view = computed(() => describeModuleViewSla(props.sla, props.nowMs))

const TONE_CLASS: Record<ModuleViewSlaTone, string> = {
  'on-time': 'bg-blue-50 text-blue-700',
  attention: 'bg-amber-100 text-amber-800',
  overdue: 'bg-red-700 text-white',
  'done-ok': 'bg-green-50 text-green-700',
  'done-neutral': 'bg-lightGray30 text-neutral50',
  none: 'border border-dashed border-neutral50/40 bg-white text-neutral50'
}

const TONE_ICON: Record<ModuleViewSlaTone, string> = {
  'on-time': mdiClockOutline,
  attention: mdiAlertOutline,
  overdue: mdiAlertCircleOutline,
  'done-ok': mdiCheck,
  'done-neutral': mdiCheck,
  none: mdiProgressClock
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("span", {
    class: _normalizeClass(["inline-flex w-fit items-center gap-1 whitespace-nowrap rounded-full px-2 py-0.5 text-xs font-semibold", TONE_CLASS[view.value.tone]]),
    "data-testid": _ctx.testId,
    "data-sla-state": view.value.state,
    "data-sla-outcome": view.value.outcome ?? undefined,
    title: view.value.text
  }, [
    (_openBlock(), _createElementBlock("svg", _hoisted_2, [
      _createElementVNode("path", {
        d: TONE_ICON[view.value.tone]
      }, null, 8, _hoisted_3)
    ])),
    _createTextVNode(" " + _toDisplayString(view.value.text), 1)
  ], 10, _hoisted_1))
}
}

})